/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { ScenarioType_Enum, scenarioType_EnumFromJSON, scenarioType_EnumToJSON } from "./scenario_type";

export const protobufPackage = "subject_spoofer";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ScenarioRequest {
  utime: number;
  scenario: ScenarioType_Enum;
}

function createBaseScenarioRequest(): ScenarioRequest {
  return { utime: 0, scenario: 0 };
}

export const ScenarioRequest = {
  encode(message: ScenarioRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.scenario !== 0) {
      writer.uint32(16).int32(message.scenario);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScenarioRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.scenario = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenarioRequest {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      scenario: isSet(object.scenario) ? scenarioType_EnumFromJSON(object.scenario) : 0,
    };
  },

  toJSON(message: ScenarioRequest): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.scenario !== 0) {
      obj.scenario = scenarioType_EnumToJSON(message.scenario);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioRequest>, I>>(base?: I): ScenarioRequest {
    return ScenarioRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioRequest>, I>>(object: I): ScenarioRequest {
    const message = createBaseScenarioRequest();
    message.utime = object.utime ?? 0;
    message.scenario = object.scenario ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
